"use client";

import { useEffect, useState } from "react";
import styles from "./global-error.module.css";

const BrokenDocIcon = () => (
  <svg
    width="83"
    height="120"
    viewBox="0 0 83 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M82.8811 78.6381C82.8693 78.5326 82.9518 78.4447 82.9224 78.3393C82.8693 78.1283 82.6631 78.0404 82.5571 77.8588C82.404 77.5893 82.2803 77.3666 82.0387 77.1791C81.8031 76.9975 81.5616 76.9447 81.2788 76.8627C81.0786 76.8041 80.9313 76.6283 80.7074 76.6283C80.6014 76.6283 80.5366 76.7279 80.4306 76.7397C80.3246 76.7514 80.2362 76.6694 80.1361 76.6986L63.8194 80.9057L53.3341 71.9585C52.4741 71.2261 51.2075 71.2261 50.3475 71.9585L40.4335 80.4194L30.5196 71.9585C29.6713 71.2261 28.393 71.2261 27.5389 71.9585L17.2066 80.7768L3.17504 74.9234C3.02188 74.859 2.86871 74.9468 2.70968 74.9175C2.55653 74.8824 2.45638 74.7418 2.29145 74.7418C2.13829 74.7418 2.03815 74.8765 1.89089 74.9058C1.57869 74.9644 1.34306 75.0582 1.07798 75.2398C0.83058 75.4039 0.665637 75.5679 0.500706 75.814C0.412345 75.9429 0.241509 75.9839 0.176725 76.1363C0.111929 76.2886 0.20618 76.4351 0.176725 76.5933C0.141382 76.7457 0 76.8511 0 77.0152V108.727C0.00589028 115.055 3.46962 120 7.8994 120H75.0359C79.501 120 83 115.055 83 108.732L82.9941 78.908C82.9941 78.8026 82.8988 78.7377 82.8811 78.6381ZM75.0348 115.441H7.89829C6.33132 115.441 4.58188 112.575 4.58188 108.731V80.449L16.699 85.5057C16.8934 85.5877 17.0937 85.5994 17.294 85.6287C17.3823 85.6404 17.4471 85.6756 17.5355 85.6756C17.5532 85.6756 17.565 85.6873 17.5826 85.6873C18.0716 85.6873 18.5251 85.4998 18.9198 85.2186C18.9787 85.1776 19.0553 85.201 19.1083 85.1541L29.0223 76.6932L38.9362 85.1541C39.1777 85.3651 39.4899 85.3768 39.7845 85.4647C39.9847 85.5291 40.1438 85.6697 40.35 85.6756C40.3794 85.6756 40.3971 85.7049 40.4265 85.7049C40.61 85.7049 40.7337 85.535 40.8986 85.4998C41.2336 85.4237 41.6164 85.4119 41.911 85.1483L51.8249 76.6874L61.7389 85.1483C61.7742 85.1775 61.8155 85.1658 61.8508 85.1893C62.0157 85.3182 62.2337 85.324 62.4281 85.4061C62.6991 85.5115 62.9465 85.699 63.2292 85.699C63.2469 85.699 63.2587 85.6815 63.2704 85.6815C63.4531 85.6815 63.6415 85.658 63.8242 85.6111L78.3977 81.8553V108.738C78.4154 112.517 76.6018 115.441 75.0348 115.441ZM0.500004 65.8356C0.670831 66.0876 0.84166 66.2634 1.09496 66.4274C1.22456 66.5153 1.25991 66.6794 1.41306 66.7438L16.7058 73.1305C16.9414 73.2301 17.1888 73.2594 17.4303 73.277C17.448 73.277 17.4598 73.2829 17.4716 73.2829C17.5128 73.2829 17.554 73.3063 17.5894 73.3063C18.1018 73.3063 18.5672 73.0954 18.9678 72.7848C19.009 72.7496 19.0738 72.7731 19.115 72.7379L29.029 64.2829L38.9429 72.7379C39.1903 72.9547 39.5084 72.9664 39.8089 73.0602C40.0033 73.1188 40.1505 73.2536 40.3567 73.2594C40.3861 73.2594 40.4097 73.2887 40.4392 73.2887C40.61 73.2887 40.7337 73.1129 40.8986 73.0778C41.258 73.0016 41.635 72.9957 41.9295 72.7379L51.8434 64.2829L61.7574 72.7379C61.7868 72.7614 61.8222 72.7496 61.8516 72.7731C62.2522 73.1012 62.747 73.3063 63.2772 73.3063C63.4833 73.3063 63.6895 73.277 63.8957 73.2184L81.3313 68.3317C81.5433 68.2731 81.6376 68.0622 81.8202 67.9508C82.0617 67.8044 82.2679 67.693 82.4387 67.4645C82.639 67.2067 82.7038 66.9489 82.7863 66.6383C82.8334 66.4567 82.9983 66.3278 82.9983 66.1286L82.9866 21.4857C82.9866 21.4154 82.9218 21.3802 82.9159 21.3099C82.8805 20.806 82.7333 20.3255 82.3798 19.9388L64.8733 0.714847C64.8616 0.703129 64.838 0.703129 64.8262 0.691411C64.7909 0.656254 64.7496 0.656254 64.7143 0.626958C64.3255 0.269538 63.8484 0.0996185 63.3359 0.0585936C63.2829 0.0527346 63.2534 0 63.2004 0H7.89875C3.54558 0 0.00523198 3.77924 0.00523198 8.43163V64.6515C0.00523198 64.8156 0.146607 64.9152 0.176058 65.0675C0.229074 65.3605 0.329177 65.5837 0.500004 65.8356ZM65.462 8.15624L75.5174 19.1895H68.7725C66.9464 19.1895 65.462 17.4492 65.462 15.3165V8.15624ZM7.89829 4.55865H60.8852V15.3165C60.8852 19.963 64.4255 23.7481 68.7728 23.7481H78.4099V64.4295L63.8305 68.5194L53.3334 59.5604C52.4733 58.828 51.2068 58.828 50.3468 59.5604L40.4328 68.0213L30.5189 59.5604C29.6588 58.828 28.3983 58.828 27.5381 59.5604L17.1823 68.4021L4.58806 63.1404L4.58217 8.43104C4.58217 6.29234 6.06633 4.55865 7.89829 4.55865ZM15.5385 37.2361C14.9082 36.1462 15.2852 34.7518 16.3867 34.1248L22.0065 30.908L18.7725 25.3123C18.1422 24.2225 18.5192 22.828 19.6208 22.201C20.6988 21.5741 22.1066 21.9432 22.7487 23.0448L25.9826 28.6346L31.6082 25.4179C32.6921 24.791 34.094 25.1601 34.7362 26.2617C35.3665 27.3515 34.9895 28.7459 33.8879 29.3729L28.2682 32.5897L31.5021 38.1854C32.1324 39.2753 31.7554 40.6697 30.6538 41.2967C30.2945 41.5018 29.8998 41.6014 29.511 41.6014C28.7217 41.6014 27.95 41.1912 27.5259 40.4588L24.292 34.8689L18.6664 38.0857C18.307 38.2908 17.9124 38.3904 17.5236 38.3904C16.7342 38.3845 15.9685 37.9744 15.5385 37.2361ZM48.3723 46.031C47.742 44.9412 48.119 43.5467 49.2147 42.9197L54.8403 39.703L51.6123 34.1131C50.9878 33.0232 51.359 31.6288 52.4605 31.0018C53.5444 30.3807 54.9581 30.7498 55.5825 31.8455L58.8106 37.4354L64.4303 34.2187C65.5319 33.5976 66.9279 33.955 67.5641 35.0624C68.1885 36.1523 67.8174 37.5467 66.7218 38.1737L61.0961 41.3905L64.3242 46.9804C64.9486 48.0702 64.5775 49.4647 63.4818 50.0917C63.1166 50.2967 62.7219 50.3963 62.339 50.3963C61.5497 50.3963 60.7721 49.9862 60.3539 49.2538L57.1258 43.6639L51.5061 46.8806C51.1409 47.0857 50.7521 47.1853 50.3633 47.1853C49.574 47.1736 48.7964 46.7634 48.3723 46.031Z"
      fill="#74001C"
    />
  </svg>
);

const ShadowEllipse = () => (
  <svg
    width="104"
    height="16"
    viewBox="0 0 104 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M52 16C80.7188 16 104 12.4183 104 8C104 3.58172 80.7188 0 52 0C23.2812 0 0 3.58172 0 8C0 12.4183 23.2812 16 52 16Z"
      fill="#74001C"
      fillOpacity="0.1"
    />
  </svg>
);

function GlobalErrorContent({ reset }: { reset: () => void }) {
  const [isArabic, setIsArabic] = useState(false);

  useEffect(() => {
    // 1. Check if the user previously selected Arabic via next-intl cookie
    const hasArabicCookie = document.cookie.includes('NEXT_LOCALE=ar') || document.cookie.includes('locale=ar');

    // 2. Fallback: check if the browser language is Arabic
    const isBrowserArabic = window.navigator.language.startsWith('ar');

    // 3. Fallback: check if the URL contains /ar
    const isArabicPath = window.location.pathname.startsWith('/ar/');

    if (hasArabicCookie || isBrowserArabic || isArabicPath) {
      setIsArabic(true);
    }
  }, []);

  const content = isArabic
    ? {
      oops: "عذراً!",
      title: "حدث خطأ ما!",
      description: "حصل خطأ غير متوقع. حاول مجدداً.",
      action: "حدث الصفحة",
      dir: "rtl"
    }
    : {
      oops: "Oops!",
      title: "Something went wrong!",
      description: "We encountered a critical error. Please try again later.",
      action: "Refresh the page",
      dir: "ltr"
    };

  // We set dir on a wrapper container since html/body are rendered outside
  return (
    <section className={styles.container} dir={content.dir} style={{ textAlign: isArabic ? "right" : "left" }}>
      <span className={styles.backdrop} aria-hidden="true">
        500
      </span>

      <div className={styles.content}>
        <div className={styles.iconWrap}>
          <BrokenDocIcon />
          <ShadowEllipse />
        </div>

        <h1 className={styles.oops}>{content.oops}</h1>
        <h2 className={styles.title}>{content.title}</h2>
        <p className={styles.description}>{content.description}</p>

        <button onClick={() => window.location.reload()} className={styles.button}>
          {content.action}
        </button>
      </div>
    </section>
  );
}

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  return (
    <html lang="en">
      <body>
        <GlobalErrorContent reset={reset} />
      </body>
    </html>
  );
}